import { createVanIconComponent } from "./van"

const FilterOutlined = createVanIconComponent("filter-o")
export default FilterOutlined
